import { memo } from 'react'

import { ISeparatorProps } from './models'

import styles from './Separator.module.scss'

export const Separator = memo<ISeparatorProps>(() => {
  return <hr className={styles.separator} />
})
